import axios from "axios";
import authHeader from "@/services/auth-header";

const main = "BytePro";
const sub = "CompPlan";

class CompPlanService {
  get(compPlanId) {
    return axios
      .get(
        `${process.env.VUE_APP_API_BASE_URL}/api/${main}/${sub}/${compPlanId}`,
        {
          headers: authHeader(),
        }
      )
      .then((response) => {
        return response;
      });
  }
}

export default new CompPlanService();
